
import { defineComponent } from "vue";
import DxTabPanel from "devextreme-vue/tab-panel";
import mountComponentMixin from "@/mixins/MountComponentMixin";

export default defineComponent({
  components: { DxTabPanel },
  mixins: [mountComponentMixin],
  props: {},
  methods: {
    onSelectTabIndex(value: any) {
      const tab = { ...this.tabs[value] };
      if (!tab.mounted) {
        (this as any).mountComponent(tab.component, tab.domId, {});
        tab.mounted = true;
      }
    },
  },
  watch: {
    selectedTabIndex: function (value: any) {
      this.onSelectTabIndex(value);
    },
  },
  data() {
    return {
      tabsRenderKey: 0,
      selectedTabIndex: 0,
      tabs: [
        {
          id: 0,
          name: "Пакеты",
          component:
            "components/catalogues/ImportSettings/PlanPackageImportSettings/PlanPackageImportSettingsCatalogue.vue",
          domId: "PlanPackageImportSettingsId",
          mounted: false,
        },
        {
          id: 1,
          name: "Контейнеры",
          component:
            "components/catalogues/ImportSettings/PlanContainerImportSettings/PlanContainerImportSettingsCatalogue.vue",
          domId: "PlanContainerImportSettingsId",
          mounted: false,
        },
        {
          id: 2,
          name: "Заказы",
          component:
            "components/catalogues/ImportSettings/PlanOrderImportSettings/PlanOrderImportSettingsCatalogue.vue",
          domId: "PlanOrdersImportSettingsId",
          mounted: false,
        },
        {
          id: 3,
          name: "Отгрузки",
          component:
            "components/catalogues/ImportSettings/PlanShipmentImportSettings/PlanShipmentImportSettingsCatalogue.vue",
          domId: "PlanShipmentsImportSettingsId",
          mounted: false,
        },
      ],
    };
  },
  mounted() {
    this.onSelectTabIndex(this.selectedTabIndex);
  },
  beforeUnmount() {
    this.tabs.forEach((tab: any) => {
      if (tab.mounted) this.unmountComponent(tab.domId);
    });
  },
});
